<template>
  <div>
    <vx-card class="mb-base">
      <div class="vx-col w-full">
        <div class="flex items-end px-3 text-primary">
          <feather-icon svgClasses="w-6 h-6" icon="CalendarIcon" class="mr-2" />
          <span class="font-medium text-xl leading-none text-primary"
            >Company Schedule</span
          >
        </div>
        <vs-divider />
      </div>
      <vs-button
        type="gradient"
        color="primary"
        @click=""
        icon-pack="feather"
        icon="icon-plus"
        >Add</vs-button
      >

      <div class="vx-col w-full mb-base">
        <template>
          <vs-table
            stripe
            v-model="selected"
            search
            :data="getAllTenantsSchedule"
          >
            <template slot="thead">
              <vs-th>daysName Type</vs-th>
              <vs-th>Type of Shift</vs-th>
              <vs-th>Time In</vs-th>
              <vs-th>Time Out</vs-th>
              <vs-th>Working Hours</vs-th>
              <vs-th>End Date</vs-th>
              <vs-th>Active</vs-th>
              <vs-th>Rest days</vs-th>
              <vs-th>From Date</vs-th>
              <vs-th>To Date</vs-th>
              <vs-th>Action</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].daysName">
                  {{ data[indextr].daysName }}
                </vs-td>
                <vs-td :data="data[indextr].shiftTypeId">
                  {{ ShiftType(data[indextr].shiftTypeId).shiftTypeName }}
                </vs-td>
                <vs-td :data="data[indextr].scheduleIN">
                  {{ data[indextr].scheduleIN }}
                </vs-td>
                <vs-td :data="data[indextr].scheduleOUT">
                  {{ data[indextr].scheduleOUT }}
                </vs-td>
                <vs-td :data="data[indextr].workedHours">
                  {{ data[indextr].workedHours }}
                </vs-td>
                <vs-td :data="data[indextr].isNoEndDate">
                  <vs-checkbox
                    v-model="data[indextr].isNoEndDate"
                    class="pointer-events-none"
                  />
                </vs-td>
                <vs-td :data="data[indextr].isActive">
                  <vs-checkbox
                    v-model="data[indextr].isActive"
                    class="pointer-events-none"
                  />
                </vs-td>
                <vs-td :data="data[indextr].isRestDay">
                  <vs-checkbox
                    v-model="data[indextr].isRestDay"
                    class="pointer-events-none"
                  />
                </vs-td>
                <vs-td
                  v-if="data[indextr].fromDate"
                  :data="data[indextr].fromDate.split('T')[0]"
                >
                  {{ data[indextr].fromDate.split("T")[0] }}
                </vs-td>
                <vs-td
                  v-if="data[indextr].toDate"
                  :data="data[indextr].toDate.split('T')[0]"
                >
                  {{ data[indextr].toDate.split("T")[0] }}
                </vs-td>

                <vs-td>
                  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
                    <!-- <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].id)" /> -->
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </template>
      </div>
    </vx-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selected: [],
      user_not_found: false,
      CompanyInformation: null,

      daysName: 0,
      scheduleIN: "8:00:00",
      scheduleOUT: "18:00:00",
      workedHours: 0,
      isNoEndDate: true,
      isActive: true,
      isRestDay: true,
      shiftTypeId: 1,
      fromDate: "",
      toDate: "",
    };
  },
  created() {
    this.$vs.loading();
    this.tenantsId = this.$route.params.tenantsId;
    console.log("Tenants ID:", this.tenantsId);
    const payload = {
      pageNumber: 1,
      pageSize: -1,
      sortBy: "CreatedOn",
      sortOrder: "Desc",
    };
    this.$store
      .dispatch("tenants/getAllTenantsSchedule", { tenantsId: this.tenantsId })
      .then((res) => {
        this.$vs.loading.close();
        if (res.data && res.data.data) {
          this.CompanyInformation = JSON.parse(JSON.stringify(res.data.data));
          console.log("tenantsId:", this.CompanyInformation);
        } else {
          console.error("Error: No data received from the API");
        }
      })
      .catch((err) => {
        this.$vs.loading.close();
        this.user_not_found = true;
        console.log("Error fetching tenant by ID. tenantsId:", this.tenantsId);
        console.error(err);
      });

    this.$store.dispatch("lookup/getAllShiftType").catch((err) => {
      console.log(err);
    });
  },
  computed: {
    getAllTenantsSchedule() {
      return this.$store.state.tenants.tenantsSchedule;
    },
    getShiftType() {
      return this.$store.state.lookup.getAllShiftType;
    },
    ShiftTypeName: {
      get() {
        return this.$store.getters["lookup/getAllShiftType"](this.shiftTypeId);
      },
      set(obj) {
        this.shiftTypeId = obj.shiftTypeId;
      },
    },
    ShiftType() {
      return (id) => this.$store.getters["lookup/shiftTypeLookup"](id);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
